import {ArchiveRecord} from 'archive/ArchiveConstants';
import {RequestTaskSchema} from 'requests/tasks/RequestTaskConstants';
import {SchemaSpec} from 'schemas/spec/SchemaConfigConstants';
import * as net from 'util/Net';

export interface RequestTaskSchemasResponse {
  requestTaskSchemasById: {[schemaId: string]: RequestTaskSchema};
}

export function fetchAll(): Promise<RequestTaskSchemasResponse> {
  return net.getJSONPromise('/1/api/request-task-schemas');
}

export interface RequestTaskSchemaResponse {
  requestTaskSchema: RequestTaskSchema;
  schemaSpec: SchemaSpec;
}

export function fetchSchemaSpec(schemaId: string): Promise<RequestTaskSchemaResponse> {
  return net.getJSONPromise(`/1/api/request-task-schemas/${schemaId}/spec`);
}

export function updateSchemaSpec(
  schemaId: string,
  schemaName: string,
  spec: SchemaSpec
): Promise<RequestTaskSchemaResponse> {
  return net.patchJSONPromise({
    url: `/1/api/request-task-schemas/${schemaId}`,
    data: {schemaName, spec},
  });
}

export function createSchema(
  ownerId: string,
  name: string,
  spec: SchemaSpec
): Promise<RequestTaskSchemaResponse> {
  return net.postJSONPromise({
    url: `/1/api/request-task-schemas`,
    data: {
      ownerId,
      name,
      spec,
    },
  });
}

export function taskSchemaListingURL(): string {
  return `/request-schemas/tasks/`;
}

export function taskSchemaURL(schemaId: string): string {
  return `/request-schemas/tasks/${schemaId}`;
}

export function taskSchemaCreateURL(): string {
  return `/request-schemas/tasks/create`;
}

interface BulkArchiveResponse {
  archivedItemIds: Array<string>;
  archiveRecordsByItemId: {[id: string]: ArchiveRecord};
}

export function bulkArchive(ids: Array<string>, purpose: string): Promise<BulkArchiveResponse> {
  return net.postJSONPromise({
    url: '/1/api/request-task-schemas:bulk-archive',
    data: {ids, purpose},
  });
}

interface BulkUnarchiveResponse {
  unarchivedItemIds: Array<string>;
}

export function bulkUnarchive(ids: Array<string>): Promise<BulkUnarchiveResponse> {
  return net.postJSONPromise({
    url: '/1/api/request-task-schemas:bulk-unarchive',
    data: {ids},
  });
}
